import { Dialog } from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";
import { closeImageModal } from "../helper/common.helper";
import { selectImageModal } from "../store/root/root.selector";

const ImageViewModal: React.FC = () => {
  const imageModal = useSelector(selectImageModal);

  return (
    <Dialog open={imageModal.open} onClose={closeImageModal}>
      <img src={imageModal.url} height="100%" width="100%" alt="modal-view" />
    </Dialog>
  );
};

export default ImageViewModal;
